define('GoogleTagManager.Fix', [
    'GoogleTagManager'
],
function GoogleTagManagerFix(
    GoogleTagManager
) {
    'use strict';

    /**
     * This code was copied from suitecommerce folder to apply a fix, it is not aligned with our eslint rules
     */

    /* eslint-disable */
    GoogleTagManager.findCategoryAndListInDataLayer = function findCategoryAndListInDataLayer(product) {
        if (SC.ENVIRONMENT.GTM_DATALAYER && SC.ENVIRONMENT.GTM_DATALAYER.events) {
            var dataLayer = SC.ENVIRONMENT.GTM_DATALAYER.events;
            var productSku = (product.get('item') && product.get('item').get('_sku')) || product.get('id');
            if(productSku)
            {
                var productClick = _.find(dataLayer, function(obj){
                    return  obj.event === 'productClick' &&
                    obj.ecommerce &&
                    obj.ecommerce.click &&
                    obj.ecommerce.click.products &&
                    productSku.indexOf(obj.ecommerce.click.products[0].id) === 0;
                });

                return {
                    category: (productClick && productClick.ecommerce.click.products[0].category) || '',
                    list: (productClick && productClick.ecommerce.click.actionField.list) || ''
                };
            }
        }
    };
    /* eslint-enable */
});

